





































import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { HasTaskMixin } from '@/mixins';
import {
  PricePlan, QueryFilters, QueryResult, QPagination,
} from '@/types';
import repository from './price-plan-repository';
import AddPricePlanModal from './AddPricePlanModal.vue';

interface Data {
  task: Promise<QueryResult>|null,
  pricePlans: PricePlan[],
  pagination: QPagination,
  columns: object[],
}

export default Vue.extend({
  mixins: [HasTaskMixin],
  props: {
    pricePlan: Object as () => PricePlan,
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      pricePlans: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      columns: [
        {
          name: 'pricing',
          align: 'center',
          label: 'Plans and Pricing',
        },
      ],
    };
  },
  watch: {
    pagination: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    getSelection(): string {
      return (this.selectable) ? 'single' : 'none';
    },
    selected(): PricePlan[] {
      if (!this.pricePlan) return [];
      return [this.pricePlan];
    },
    filters(): QueryFilters {
      return {
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
      };
    },
  },
  methods: {
    openEditModal(pricePlan: PricePlan): void {
      const config = {
        pricePlan,
        mode: 'Edit',
      };
      openModal(AddPricePlanModal, config)
        .onOk((pp: PricePlan) => {
          this.update(pp);
        });
    },
    selectPricePlan(pricePlans: PricePlan[]): void {
      this.$emit('selected', pricePlans[0]);
    },
    add(pricePlan: PricePlan): void {
      this.pricePlans.unshift(pricePlan);
    },
    update(pricePlan: PricePlan): void {
      const index = this.pricePlans.findIndex(pp => pp.id === pricePlan.id);
      if (index >= 0) {
        this.pricePlans.splice(index, 1, pricePlan);
      }
    },
    load() {
      this.task = repository.findAll(this.filters);
      this.task.then((result: QueryResult) => {
        this.pricePlans = (result.items as PricePlan[]);
        this.pagination.rowsNumber = result.total;
      });
    },
    isGranted,
  },
  created(): void {
    this.load();
  },
});
